// import axios from 'axios';

import Http from './http';
let http = Http.Http;
import globaleData from './globalData'
// 登录

function refreshSession(data) {
	setTimeout(() => {
		Login(data);
		console.log(111, data)
	}, 19 * 60 * 1000)
}

// 登录
function Login(data) {
	return new Promise((resolve, reject) => {
		http({
			url: '/api/admin/users/login',
			method: 'post',
			data
		})
			.then((res) => {
				refreshSession(data)
				sessionStorage.setItem('sskey', res.data);
				// sessionStorage.setItem('userInfo', JSON.stringify(res.data));

				globaleData.sessionKey = res.data;
				// globaleData.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
				resolve(res)
			})
			.catch((error) => {
				reject(error)
			});
	})
}

// 登出
function Logout() {
	return new Promise((resolve, reject) => {
		http({
			url: '/api/admin/users/logout',
			method: 'delete'
		}).then((res) => {
			resolve(res)
		}).catch((error) => {
			reject(error)
		})
	})
}

export {
	Login,
	Logout
}



// WEBPACK FOOTER //
// ./src/service/login.js